import { useAuth } from "@/modules/auth/hooks/useAuth";

// Signup stores ISO2 on both rows; internally created organizations may carry ISO3.
const MEXICO_CODES = new Set(["MX", "MEX"]);

export function useIsMexicanOrganization(): boolean {
  const { user } = useAuth();
  const country = user?.organization?.country ?? user?.country ?? "";
  return MEXICO_CODES.has(country.toUpperCase());
}
